/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section, Slide } from 'spectacle-ppa';
import SelectConfiguration from 'components/selectConfiguration';
import SelectDeviceRole from 'components/selectDeviceRole';

import htmlSlide from '../../baseSlides/htmlSlide';
import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileTechPrep from './tech_prep.md';

const techPrepMd = new MarkdownScript(markdownFileTechPrep);

function techPrepWizard ({ regionData }) {
  return htmlSlide({
    id: 'tech-prep-wizard',
    html: techPrepMd.getSectionAsHtml('Tech Prep Wizard', false, regionData)
  });
}

function twoDeviceIntro ({ regionData }) {
  return htmlSlide({
    id: 'two-device-intro',
    html: techPrepMd.getSectionAsHtml('Two Device Intro', false, regionData)
  });
}

function selectConfiguration () {
  return (
    <Slide
        id="configuration"
        textColor="white">
      <SelectConfiguration />
    </Slide>
  );
}

function connectingRemote ({ configuration, regionData }) {
  if (configuration === 'dualScreen') {
    return htmlSlide({
      id: 'connecting-remote',
      html: techPrepMd.getSectionAsHtml('Connecting Remote', false, regionData)
    });
  } else {
    return null;
  }
}

function selectDeviceRole (configuration) {
  if (configuration === 'dualScreen') {
    return (
      <Slide
          id="device-role"
          textColor="white">
        <SelectDeviceRole />
      </Slide>
    );
  } else {
    return null;
  }
}

function techCheckIntro ({ regionData }) {
  return htmlSlide({
    id: 'tech-check-intro',
    html: techPrepMd.getSectionAsHtml('Tech Check Intro', false, regionData)
  });
}

function techCheckVideo ({ regionData }) {
  return videoSlide({
    id: 'tech-check-video',
    youTubeId: techPrepMd.getSectionMetadata('Tech Check Video', 'YouTube', regionData)
  });
}

function levelPrep ({ configuration, regionData }) {
  return (

    <Section id="prep">

      {/* Tech Prep Wizard */}
      {techPrepWizard({ regionData })}

      {/* Two Device Intro */}
      {twoDeviceIntro({ regionData })}

      {/* Select Configuration */}
      {selectConfiguration()}

      {/* Connecting Remote Instructions */}
      {connectingRemote({ configuration, regionData })}

      {/* Select Device Role */}
      {selectDeviceRole(configuration)}

      {/* Tech Check Intro */}
      {techCheckIntro({ regionData })}

      {/* Tech Check Video */}
      {techCheckVideo({ regionData })}

      {/* Start Level */}

    </Section>
  );
}

function levelCompletedPrep ({ configuration, regionData }) {
  return (

    <Section id="prep">

      {/* Select Configuration */}
      {selectConfiguration()}

      {/* Connecting Remote */}
      {connectingRemote({ configuration, regionData })}

      {/* Select Device Role */}
      {selectDeviceRole(configuration)}

    </Section>
  );
}


function prepSection ({ level, configuration, regionData }) {
  switch (level) {
  case '1':
    return levelPrep({ configuration, regionData });
  case '2':
    return levelPrep({ configuration, regionData });
  case '3':
    return levelPrep({ configuration, regionData });
  case 'completed':
    return levelCompletedPrep({ configuration, regionData });
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default prepSection;



// WEBPACK FOOTER //
// ./programs/epsHybridIntermediates/sections/00_prep/prepSection.jsx